<template>
  <CardedDisplay>
    <PlainDisplay icon="" cmp_class="mt-0 pt-0">
      <b><v-icon>mdi-home-map-marker</v-icon> Directions To Our Business: </b>
      {{ business.manual_directions }}
    </PlainDisplay>
    <div class="d-flex justify-space-between align-center pr-5 pl-5 mt-2">
      <div>
        <v-img
          width="200"
          height="200"
          max-height="200"
          contain
          src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605688003/botswana%20services/website%20assets/botswana-political-map_ywzvrz.jpg"
        >
        </v-img>
      </div>
      <div class="flex-grow-1 pl-6">
        <div class="wdth-70pz">
          <DashedFact
            left_value="District"
            :right_value="business.district ? business.district.name : ''"
          ></DashedFact>
          <DashedFact
            left_value="City"
            :right_value="business.city ? business.city.name : ''"
          ></DashedFact>
          <DashedFact
            left_value="Ward"
            :right_value="business.ward ? business.ward.name : ''"
          ></DashedFact>
          <DashedFact
            left_value="Street"
            :right_value="business.street ? business.street.name : ''"
          ></DashedFact>
          <DashedFact
            left_value="Physical Address"
            :right_value="business.physical_address"
          ></DashedFact>
        </div>
      </div>
    </div>
    <br />
    <v-alert
      dense
      text
      type="warning"
      v-if="is_owner && has_setup_map == false"
      class="text-left"
    >
      Please note that
      <strong> you have not yet setup, a pin location on google maps </strong>
      for your business, please click the
      <v-btn
        small
        class="mr-4"
        text
        :disabled="is_loading"
        :to="
          '/owner/businesses/list/view/' +
          this.business.id +
          '/locations/manage'
        "
        color="black"
      >
        Manage Location Info
      </v-btn>
      button to set it up.
    </v-alert>

    <v-alert
      dense
      text
      type="warning"
      v-if="!is_owner && has_setup_map == false"
    >
      This <strong> business has not yet setup its location on the map</strong>
    </v-alert>
    <GeoMap :business="business" :is_owner="is_owner"></GeoMap>
  </CardedDisplay>
</template>

<script>
import CardedDisplay from "./../components/CardedDisplay";
import PlainDisplay from "./../components/PlainDisplay";
import DashedFact from "./../components/DashedFact";
import Utils from "./../lib/Utils";
import GeoMap from "./../components/GeoMap";
export default {
  name: "BusinessViewLocation",
  components: {
    CardedDisplay,
    PlainDisplay,
    DashedFact,
    GeoMap,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
  },
  data: () => {
    return {};
  },
  methods: {},
  computed: {
    has_setup_map() {
      var lat = parseFloat(this.business.lat);
      var lng = parseFloat(this.business.lng);
      if (lat == 0 || lng == 0) {
        return false;
      }
      return true;
    },
  },
  mounted() {},
};
</script>

